import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { ProgrammeCard } from './ProgrammeCard';
import { ComplianceNotice, FormPrivacyConsent } from '../LegalNotices';
import { programmes } from '../../content/programmes';
import { DATA_PRIVACY_NOTICE, FREE_SESSION_OFFER, LARGER_ORGANISATIONS, PILOT_OFFER, PRIVACY_PATH } from '../../content/legal';
import { heroData } from '../../mock';

export const PricingSection = ({ onPilot }) => (
  <section id="pricing" data-testid="pricing-section" className="scroll-mt-24 bg-white px-6 py-20">
    <div className="container mx-auto max-w-7xl">
      <div data-testid="free-session-banner" className="mb-16 border-y border-[#604f9b]/25 bg-[#604f9b]/5 px-5 py-8 sm:px-8">
        <p data-testid="free-session-offer" className="max-w-4xl text-base leading-relaxed text-gray-800">{FREE_SESSION_OFFER}</p>
        <div className="mt-5 flex flex-col items-start gap-4 md:flex-row md:items-center">
          <Button asChild className="h-auto bg-[#f49e38] px-6 py-3 text-white hover:bg-[#e08a28]">
            <a data-testid="free-session-banner-booking-link" href={heroData.calendlyLink} target="_blank" rel="noopener noreferrer">Book a free session <ArrowRight aria-hidden="true" className="ml-2 h-4 w-4" /></a>
          </Button>
          <p data-testid="free-session-call-clarification" className="text-sm text-gray-600">Book a 30-minute call to discuss the free 45-minute session.</p>
        </div>
        <FormPrivacyConsent testId="booking-privacy-consent" className="mt-4" />
      </div>
      <div className="mb-16 text-center">
        <h2 data-testid="pricing-heading" className="mb-4 text-4xl font-bold text-gray-900 md:text-5xl">Flexible, Scalable Financial Wellbeing Programmes</h2>
      </div>
      <div className="mb-10 grid gap-x-8 gap-y-12 lg:grid-cols-3">
        {programmes.map((programme) => <ProgrammeCard key={programme.id} programme={programme} onPilot={onPilot} />)}
      </div>
      <div className="space-y-5 border-t border-gray-200 pt-8">
        <ComplianceNotice short testId="pricing-compliance-notice" className="font-medium text-gray-800" />
        <p data-testid="larger-organisations-notice" className="text-base leading-relaxed text-gray-700">{LARGER_ORGANISATIONS}</p>
        <p data-testid="pilot-offer" className="text-base leading-relaxed text-gray-700">{PILOT_OFFER}</p>
      </div>
      <div data-testid="pricing-data-privacy-section" className="mt-10 border-t border-gray-200 pt-8">
        <h3 className="mb-4 text-lg font-bold text-gray-900">Data and privacy</h3>
        <p data-testid="pricing-data-privacy-notice" className="max-w-5xl text-sm leading-relaxed text-gray-700">{DATA_PRIVACY_NOTICE}</p>
        <a data-testid="pricing-privacy-link" href={PRIVACY_PATH} className="mt-4 inline-block font-medium text-[#7c4a97] underline underline-offset-4">Privacy Notice</a>
      </div>
    </div>
  </section>
);